import {SidebarUsedBy as UsedByComponent} from '@github-ui/code-view-sidebar/components/SidebarUsedBy'
import type {SidebarUsedByResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarUsedBy({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'usedBy', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/used-by`)
      return (await r.json()) as SidebarUsedByResponse
    },
  })

  if (!data) return null
  return <UsedByComponent {...data} />
}
